import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type {
  PurchaseStatistics,
  PurchaseStatisticsParams,
} from '~/features/purchase/types/purchase.type';

/**
 * 구매 통계 조회
 * @description 구매 통계 정보를 조회합니다
 * @endpoint GET /admin/purchases/statistics
 * @param params - 조회 파라미터
 * @returns 구매 통계
 */
export function getPurchaseStatisticsApi(params?: PurchaseStatisticsParams) {
  return axiosInstance.get<ApiResponse<PurchaseStatistics>>('/admin/purchases/statistics', {
    params,
  });
}
